export const translations = {
  en: {
    brand: "DLSPORT",
    nav: {
      dashboard: "Dashboard",
      avatar: "Avatar Studio",
      coach: "AI Coach",
      stats: "Stats",
      programs: "Training",
      journal: "Journal",
      video: "Video AI",
      medical: "Medical",
      daily: "Daily Log",
      report: "Weekly Report",
      team: "My Team",
      club: "Club Dashboard",
      pricing: "Pricing",
      compare: "Compare",
      billing: "Subscription",
      login: "Login",
      register: "Sign up",
      logout: "Logout",
    },
    landing: {
      eyebrow: "GPT 5.6 TERRA · NANO BANANA VISION",
      title1: "Your AI",
      title2: "Football Twin",
      title3: "gets you to the top.",
      subtitle: "Upload one photo. Get a hyper-real athletic version of yourself, a tactical AI coach, personalized training programs and progress you can actually see.",
      ctaPrimary: "Create my AI player",
      ctaSecondary: "See how it works",
      feature1Title: "AI Avatar Studio",
      feature1Desc: "Turn your photo into pro-grade portraits: physical ideal, kinetic pose and stadium hero.",
      feature2Title: "Tactical Coach",
      feature2Desc: "Chat 1-on-1 with GPT 5.6 Terra tuned for football performance & recovery.",
      feature3Title: "Stats Tracker",
      feature3Desc: "Log speed, VO2, muscle index, explosive power. See your evolution week by week.",
      feature4Title: "Training Programs",
      feature4Desc: "AI-generated multi-day plans tailored to your goal and level.",
      feature5Title: "Before / After",
      feature5Desc: "A visual journal of your body transformation with side-by-side comparisons.",
      howTitle: "Three moves to elite",
      how1: "Sign up & upload your photo",
      how2: "Get your AI twin and coach",
      how3: "Track, train, transform",
      footer: "Built for footballers who don't wait to be scouted.",
    },
    auth: {
      loginTitle: "Welcome back",
      registerTitle: "Start your evolution",
      email: "Email",
      password: "Password",
      name: "Full name",
      position: "Position",
      submitLogin: "Login",
      submitRegister: "Create account",
      toLogin: "Have an account? Login",
      toRegister: "New here? Sign up",
    },
    dashboard: {
      welcome: "Welcome back",
      quickAvatar: "Generate an Avatar",
      quickCoach: "Ask the Coach",
      quickProgram: "Build a Program",
      quickStats: "Log a stat",
      recentAvatars: "Recent avatars",
      empty: "Nothing yet — start with one photo.",
    },
    avatar: {
      title: "Avatar Studio",
      subtitle: "Upload one clear photo. Pick a style. The AI does the rest.",
      upload: "Upload photo",
      variantIdeal: "Physical Ideal",
      variantKinetic: "In-Match Kinetic",
      variantStadium: "Stadium Hero",
      generate: "Generate",
      generating: "Generating…",
      gallery: "Your gallery",
    },
    coach: {
      title: "Tactical AI Coach",
      placeholder: "Ask about training, nutrition, tactics, recovery…",
      send: "Send",
      newSession: "New chat",
      thinking: "Coach is thinking…",
    },
    stats: {
      title: "Performance Telemetry",
      add: "Log new metrics",
      weight: "Weight (kg)",
      height: "Height (cm)",
      speed: "Top Speed (km/h)",
      vo2: "VO2 Max",
      muscle: "Muscle Index",
      power: "Explosive Power",
      note: "Note",
      save: "Save",
      history: "History",
    },
    programs: {
      title: "AI Training Programs",
      goal: "Your goal",
      goalPh: "e.g. Increase sprint speed and endurance",
      days: "Days / week",
      level: "Level",
      levels: { beginner: "Beginner", intermediate: "Intermediate", elite: "Elite" },
      generate: "Generate program",
      generating: "Cooking your plan…",
      library: "Your programs",
    },
    journal: {
      title: "Progression Journal",
      subtitle: "Upload a photo now, and again in 30 days. See the delta.",
      upload: "Upload photo",
      caption: "Caption",
      weight: "Weight (kg)",
      save: "Save entry",
      entries: "Entries",
      compare: "Compare",
    },
    common: { loading: "Loading…", cancel: "Cancel", delete: "Delete", close: "Close" },
  },
  fr: {
    brand: "DLSPORT",
    nav: {
      dashboard: "Tableau",
      avatar: "Studio Avatar",
      coach: "Coach IA",
      stats: "Stats",
      programs: "Entraînement",
      journal: "Journal",
      video: "Analyse Vidéo",
      medical: "Médical",
      daily: "Suivi Jour",
      report: "Rapport Hebdo",
      team: "Mon Équipe",
      club: "Espace Club",
      pricing: "Tarifs",
      compare: "Comparaison",
      billing: "Abonnement",
      login: "Connexion",
      register: "S'inscrire",
      logout: "Déconnexion",
    },
    landing: {
      eyebrow: "GPT 5.6 TERRA · VISION NANO BANANA",
      title1: "Ton double IA",
      title2: "de footballeur",
      title3: "t'emmène au sommet.",
      subtitle: "Une photo. Une version hyperréaliste de toi, un coach IA tactique, des programmes sur-mesure et des progrès visibles à l'œil nu.",
      ctaPrimary: "Créer mon joueur IA",
      ctaSecondary: "Voir comment ça marche",
      feature1Title: "Studio Avatar IA",
      feature1Desc: "Transforme ta photo en portrait pro : physique idéal, action et hero stadium.",
      feature2Title: "Coach Tactique",
      feature2Desc: "Discute avec GPT 5.6 Terra, calibré pour la perf football et la récup.",
      feature3Title: "Suivi Stats",
      feature3Desc: "Vitesse, VO2, indice musculaire, explosivité — ton évolution en clair.",
      feature4Title: "Programmes IA",
      feature4Desc: "Plans multi-jours générés selon ton objectif et ton niveau.",
      feature5Title: "Avant / Après",
      feature5Desc: "Un journal visuel de ta transformation, côte à côte.",
      howTitle: "Trois gestes pour passer élite",
      how1: "Inscris-toi et charge une photo",
      how2: "Reçois ton double IA et ton coach",
      how3: "Trace, entraîne, transforme",
      footer: "Fait pour les footballeurs qui n'attendent pas d'être repérés.",
    },
    auth: {
      loginTitle: "Bon retour",
      registerTitle: "Lance ton évolution",
      email: "Email",
      password: "Mot de passe",
      name: "Nom complet",
      position: "Poste",
      submitLogin: "Se connecter",
      submitRegister: "Créer un compte",
      toLogin: "Déjà inscrit ? Se connecter",
      toRegister: "Nouveau ? S'inscrire",
    },
    dashboard: {
      welcome: "Content de te revoir",
      quickAvatar: "Générer un avatar",
      quickCoach: "Parler au Coach",
      quickProgram: "Créer un programme",
      quickStats: "Ajouter une stat",
      recentAvatars: "Avatars récents",
      empty: "Rien encore — commence par une photo.",
    },
    avatar: {
      title: "Studio Avatar",
      subtitle: "Charge une photo nette. Choisis un style. L'IA fait le reste.",
      upload: "Charger photo",
      variantIdeal: "Physique Idéal",
      variantKinetic: "Action Match",
      variantStadium: "Hero Stadium",
      generate: "Générer",
      generating: "Génération…",
      gallery: "Ta galerie",
    },
    coach: {
      title: "Coach IA Tactique",
      placeholder: "Pose une question sur entraînement, nutrition, tactique, récup…",
      send: "Envoyer",
      newSession: "Nouveau chat",
      thinking: "Le coach réfléchit…",
    },
    stats: {
      title: "Télémétrie Performance",
      add: "Nouvelles mesures",
      weight: "Poids (kg)",
      height: "Taille (cm)",
      speed: "Vitesse max (km/h)",
      vo2: "VO2 Max",
      muscle: "Indice musculaire",
      power: "Puissance explosive",
      note: "Note",
      save: "Enregistrer",
      history: "Historique",
    },
    programs: {
      title: "Programmes IA",
      goal: "Ton objectif",
      goalPh: "ex : Augmenter vitesse et endurance",
      days: "Jours / semaine",
      level: "Niveau",
      levels: { beginner: "Débutant", intermediate: "Intermédiaire", elite: "Élite" },
      generate: "Générer le programme",
      generating: "Fabrication du plan…",
      library: "Tes programmes",
    },
    journal: {
      title: "Journal de Progression",
      subtitle: "Charge une photo aujourd'hui, une autre dans 30 jours. Vois la différence.",
      upload: "Charger photo",
      caption: "Légende",
      weight: "Poids (kg)",
      save: "Enregistrer",
      entries: "Entrées",
      compare: "Comparer",
    },
    common: { loading: "Chargement…", cancel: "Annuler", delete: "Supprimer", close: "Fermer" },
  },
};

export const getT = (lang) => translations[lang] || translations.en;
